import * as React from 'react';
import { useParams } from 'react-router-dom';
import { ReportTokenContext } from '../queryHooks';
import ReportView from './ReportView';

/** Standalone report. No app navigation, so a logged-out visitor only sees this page. */
const PublicReportPage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    return (
        <ReportTokenContext.Provider value={token}>
            <div className="force-light" style={{ maxWidth: 1200, margin: '0 auto', padding: 24, background: '#fff', minHeight: '100vh' }}>
                <ReportView />
            </div>
        </ReportTokenContext.Provider>
    );
};

export default PublicReportPage;
